import { useLoading } from "@website/ui/loading/loading.hook";
import styles from "@website/ui/loading/loading.module.scss";
import { LoadingPropertiesType } from "@website/ui/loading/loading.types";
import { FC, memo } from "react";

const Loading: FC<LoadingPropertiesType> = (properties) => {
  const { rootProps } = useLoading();
  const { color = "primary", size = "lg", children } = properties;

  return (
    <>
      {children ? <span>{children}</span> : null}
      <span
        {...rootProps}
        className={`${styles["container"]} ${styles[color]} ${styles[size]}`}
      >
        <span className={`${styles["dot"]} ${styles["odd"]}`} />
        <span className={`${styles["dot"]} ${styles["even"]}`} />
        <span className={`${styles["dot"]} ${styles["odd"]}`} />
      </span>
    </>
  );
};

const LoadingMemoized = memo(Loading);
export { LoadingMemoized as Loading };
